module.exports = __webpack_public_path__ + "static/media/image_3.b9489d40.png";